export default __webpack_public_path__ + "static/media/Standard27.e6d34c8f.png";